export default __webpack_public_path__ + "static/media/func2.3f60cf66.png";